<script>
import { mapGetters } from 'vuex'
import BaseDatatable from '@components/base-datatable'
import { euroCouponsCouponMethods } from '@state/helpers'
import CustomDatePickerRange from '@components/CustomDatePickerRange'


export default {
  name: 'RedeemedCouponsTable',

  components: { 
    BaseDatatable,
    CustomDatePickerRange 
  },
  data() {
    return {
      loadingReport: false,
      tableHeaders: [],
      filterset : null,
      filters: {
        'redemption_date__gte': null,
        'redemption_date__lte': null,
      }
    }
  },

  beforeMount(){
    this.tableHeaders = [
        { 
          key: 'redemption_date', 
          label: this.$t('date'),
          formatter: value => {
              return this.$strFormatDate(value)} ,
        },
        { key: 'time', label: this.$t('time') },
        { key: 'CO', label: this.$t('CO') },
        { key: 'cash_register', label: this.$t('cash_register') },
        { 
          key: 'value', 
          label: this.$t('value'),
          formatter: value => {
              return this.$formatDollar(value)} },
    ]
  },

  watch: {
      filters: {
        deep: true,
        handler(filters) {
          let filters_list = []
          for (let filter in filters) {
            if (filters[filter]) {
              filters_list.push(`${filter}=${new Date(filters[filter]).toISOString()}`)
            }
          }
          if (filters_list.length) {
            this.filterset = filters_list.join('&')
          }
          this.filter()
        },
      },
    },
    
  computed: {
    ...mapGetters({
      stores: 'captacionPos/stores',
      store: 'captacionPos/store',
      cashRegister: 'captacionPos/cashRegister',
    })
  },

  methods: {
    ...euroCouponsCouponMethods,

    myProvider(ctx) {
      let context = this
      ctx = context.$table_params(ctx)
      
      ctx += context.filterset ? `&${context.filterset}` : ''
      ctx+= `&CO=${context.store.store_code}`
      ctx+= `&cash_register=${context.cashRegister.id}`
      const promise = context.fetchEuroCouponsCouponRedeemed(ctx)
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },

    getReport() {
      let _ = this
      _.loadingReport = true
      
      let query = ''
      query += _.filterset ? `?${_.filterset}`: '?'
      query += `&CO=${_.store.store_code}`
      query += `&cash_register=${_.cashRegister.id}`
      const promise = _.fetchRedeemedReport({
        query: query,
        type: { responseType: 'arraybuffer' },
      })
      return promise
        .then((response) => {
          const data = response.data
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/pdf',
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Reporte Caja - Bonos Redimidos.pdf`)
          document.body.appendChild(link)
          link.click()
          _.loadingReport = false
        })
        .catch((error) => {
          _.loadingReport = false
            console.error(error)
          _.$axios_error_noty('Se presento un error en la descarga del archivo.', )
        })
    },





    setFilter(filter, value) {
      this.filters[filter] = value
    },

    filter() {
      this.$refs.table.lastFilter = ''
      this.$refs.table.onFiltered()
      setTimeout(() => this.$refs.table.refresh(), 200)
    },

    clear() {
      this.filters.redemption_date__gte = null
      this.filters.redemption_date__lte = null
      this.filterset = null
      setTimeout(() => this.refresh(), 200)
    },
  },
}
</script>

<template>
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow">
            <b-row>
              <b-col md="8" class="p-0">
                <b-col>
                  <CustomDatePickerRange
                    :label="'redemption_date'"
                    :is_datetime="true"
                    :value_start="filters.redemption_date__gte"
                    :value_end="filters.redemption_date__lte"
                    @input_start="
                      (value) => setFilter('redemption_date__gte', value)
                    "
                    @input_end="
                      (value) => setFilter('redemption_date__lte', value)
                    "
                /></b-col>
              </b-col>
              <b-col md="2" class="ml-auto pt-3 pr-1 mt-1">
                <b-button
                  class="ml-1 rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="filter"
                  >
                  <i class="fas fa-filter"></i>
                </b-button>
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>

            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:buttons>
                <b-button variant="outline-primary rounded-lg  mx-1"
                  @click="getReport">
                    <b-spinner v-if="loadingReport" label="Spinning" small></b-spinner>
                    <i v-else class="fas fa-download"></i>
                </b-button>
              </template>
              <template v-slot:cell(time)="row">
                {{$strFormatTime(row.item.redemption_date)}}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="()=>{showDetail=true; toDetail=row.item}"
                  >
                    <i
                      class="fe-info fe-2x"
                    ></i>
                  </b-button>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="()=>{showForm=true; toUpdate=row.item}"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

</template>
